export default function (config) {
  config.headers.Authorization = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGkzNjgzYjRiNi1hMzAxLTRiZWItODg5OC00YmZiYTYzMGFjM2MiLCJ4bW9kIjoxNjU0NDQ0NzQzMDAwLCJuYmYiOjE2NTQ0NDQ3NDMsImlzcyI6InVzc3NhLXByb2QiLCJsYWJlbCI6IkFkbWluIEFQSSBUb2tlbiIsImV4cCI6MTc0OTA5NjAwMCwiaWF0IjoxNjU0NDQ0NzQzLCJqdGkiOiJiYTM3ZDYxZi02N2ZjLTQ4ZTktYmJlZC0yNjUxNjJhN2M4MzIifQ.WIYF8Q8Cn_N6XjSOEQf0br3WFv2bIPZfkE6k5mXqRvg'
  config.params = { host_id: '0347de547ca8e84218eaf4ecff6566bb' }

  return config
}
